export function ticker(_sel) {
    const tickerInner = _sel.querySelector('.site-marquee__ticker-inner');
    const tickerContentWrapper = _sel.querySelector('.site-marquee__ticker-inner-wrapper');
    const tickerContent = tickerContentWrapper.innerHTML;

    // Duplicate the ticker content to ensure it can scroll continuously
    tickerContentWrapper.innerHTML += tickerContent;

    let scrollAmount = 0;

    function scrollTicker() {
        scrollAmount -= 0.75; // Adjust the value to control the scroll speed
        if (Math.abs(scrollAmount) >= tickerContentWrapper.scrollWidth / 2) {
            scrollAmount = 0;
        }
        tickerInner.style.transform = `translateX(${scrollAmount}px)`;
        requestAnimationFrame(scrollTicker);
    }

    scrollTicker();

}